module.exports = __webpack_public_path__ + "08da38c2ff1e898275b022ed847967e2.png";